module.exports = __webpack_public_path__ + "static/img/szafa_dso_45.6e95850.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/kopai/szafa_dso_45.svg
// module id = YjzZ
// module chunks = 1